export default {
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: 'Nama Kolom',
          thStyle: 'width: 30%;'
        },
        {
          key: 'key',
          label: 'Key Kolom',
          thStyle: 'width: 30%;'
        },
        {
          key: 'type',
          label: 'Tipe Kolom',
          thStyle: 'width: 30%;'
        },
        {
          key: 'is_active',
          label: 'Aktif',
          thStyle: 'min-width: 100px;'
        },
        {
          key: 'button_action',
          label: '',
          thStyle: 'width: 50px;'
        }
      ]
    }
  }
}